export const Images = {
    logo : require('../assets/logo.png'),
    plage : require('../assets/plage.jpeg'),
    male : require('../assets/man.png'),
    female : require('../assets/woman.png'),
}